import { render, staticRenderFns } from "./TenderComponent.vue?vue&type=template&id=1537268a&scoped=true"
import script from "./TenderComponent.vue?vue&type=script&lang=js"
export * from "./TenderComponent.vue?vue&type=script&lang=js"
import style0 from "./TenderComponent.vue?vue&type=style&index=0&id=1537268a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1537268a",
  null
  
)

export default component.exports